import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import DatePickerInput from '../../infra/components/formInput/DatePickerInput'

import ActionAdd from '../../store/action/ReportSession/Request'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import ActionEdit from '../../store/action/Supervisor/Edit'
import {IsEdit, IsCreate, IsView } from '../../store/constants'
import {ClientId,DivisionId,SenderId,PrevilageId} from '../../helper/HelperAuth'
import ActionGetAccessModuleIdAction from '../../store/action/AccessModule/FetchActionDispatch'
import moment from "moment";

class Form extends Component{

    constructor(props){
        super(props);
        this.state ={
            form : fromJS({
                'client-id' : '',
                'division-id' : '',
                'sender-id' : '',
                'start-date' : '',
                'end-date' : '',
                'conversation-type' : '',
                'report-format' : ''
            }),
            loadded: false,
            disabled: false,
            disableHead:true,
            errors: fromJS({}),
            error: '',
            reportFormat : fromJS ([
                {
                    'reportFormat-id' : 1,
                    'reportFormat-name' : 'All'
                },
                {
                    'reportFormat-id' : 2,
                    'reportFormat-name' : 'Summary'
                },
                {
                    'reportFormat-id' : 3,
                    'reportFormat-name' : 'Detail'
                },
            ]),

            conversationType : fromJS ([
                {
                    'conversation-type-id' : 'authentication',
                    'conversation-type-name' : 'Authentication'
                },
                {
                    'conversation-type-id' : 'marketing',
                    'conversation-type-name' : 'Marketing'
                },
                {
                    'conversation-type-id' : 'utility',
                    'conversation-type-name' : 'Utility'
                },
                {
                    'conversation-type-id' : 'service',
                    'conversation-type-name' : 'Service'
                },
            ]),
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount(){
        this.props.actionGetAllClient();
        this.props.actionGetAllDivision();
        this.props.actionGetAccessModuleIdAction('Report Session');
    }

    handleChange(field, value, label) {
        let formVal = this.state.form;
        formVal = formVal.set(field,value);
        if (value == null || value == undefined){
            value = '';
        }

        if(field === 'client-id'){
            if(value) {
                this.props.actionGetAllDivision(value);
                this.props.actionGetAllSender(value);
            } else {
                formVal = formVal.set('division-id',null);
                formVal = formVal.set('sender-id',null);
            }
        }

        if(field === 'contact-msisdn'){
            if(!value.startsWith('62')){
                value = `62${value}`
            }
        }

        if(field === 'spv-id'){
            this.props.actionGetCS(value)
        }

        this.setState({ form:formVal })
    }

    async handleSubmit(dispatch) {
        const {form} = this.state;
        let isValid = true;
        const mandatoryField = fromJS(['client-id','division-id','sender-id','start-date','end-date','report-format'])

        let newErrors = fromJS({});
        mandatoryField.map((field) => {
            if(!form.get(field)){
                isValid = false;
                newErrors = newErrors.set(field)
            }
        })

        this.setState({ errors: newErrors })

        if(!isValid){
            toast.error("Mandatory Field Cannot Empty!",toast.POSITION.TOP_RIGHT)
        }

        if(isValid){

            switch(this.props.actionType) {
                case IsCreate:
                    await this.SubmitNewData();
                    break;
                default:
                // code blocks
            }

        }
    }

    async SubmitNewData(){
        const form = this.state.form;
        let data =
            { 'filter' : {
                    'client-id' : form.get('client-id'),
                    'division-id' : form.get('division-id'),
                    'sender-id' :  form.get('sender-id'),
                    'start-date' : `${form.get('start-date')} 00:00:00`,
                    'end-date' : `${form.get('end-date')} 23:59:59`,
                    'conversation-type' : form.get('conversation-type') == null? "":form.get('conversation-type'),
                    'report-format' : form.get('report-format')
                }
            };

        console.log(data)

        let response = await this.props.actionAdd(data);
        if(response.ok){
            toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
            this.props.handleCancelForm(true);
        }else{
            toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }
    }

    handleCancel(){
        this.props.handleCancelForm(false);
    }

    componentWillMount(){
        if (this.props.item != null || this.props.item !== undefined) {
            if ((this.props.actionType === IsCreate) && !this.state.loadded) {
                let varActionId = "";
                let dataAkses = null;

                setTimeout(() => {
                    //debugger
                    dataAkses = this.props.accessmoduleaction;
                    if (dataAkses) {
                        varActionId = dataAkses.get("action-id");
                        this.setState({ actionId: varActionId });
                        if (varActionId == 5) {
                            this.props.actionGetAllDivision(ClientId);
                            this.props.actionGetAllSender(ClientId);
                            this.setState({
                                form: fromJS({
                                    'client-id': ClientId,
                                    'division-id': DivisionId,
                                    'sender-id': SenderId,
                                    'spv-name' :'',
                                    'template-id' : '',
                                    'start-date' : '',
                                    'end-date' : '',
                                    'msisdn': '',
                                    'ticket-no': '',
                                    'cs-id': '',
                                    'spv-id': '',
                                    'priority-id': '',
                                    'category-id': '',
                                    'status': "open",
                                }),
                                loadded: true,
                                disableHead: true
                            })
                        } else {
                            this.setState({
                                form: fromJS({
                                    'client-id': '',
                                    'division-id': '',
                                    'sender-id': '',
                                    'spv-name' :'',
                                    'template-id' : '',
                                    'start-date' : '',
                                    'end-date' : '',
                                    'msisdn': '',
                                    'ticket-no': '',
                                    'cs-id': '',
                                    'spv-id': '',
                                    'priority-id': '',
                                    'category-id': '',
                                    'status': "open",
                                }),
                                loadded: true,
                                disabled: (this.props.actionType === IsView),
                                disableHead: false
                            })
                        }
                    }
                }, 8000);
            }
        }
    }

    render(){
        const { form, errors, disabled, reportFormat, conversationType} = this.state;
        return (
            <div className="card no-margin-bottom">
                <div className="body">
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Client * </span>
                        <div className="col-sm-4">
                            <ComboboxInput
                                field='client-id'
                                value={form.get('client-id')}
                                options={fromJS({
                                    'source': this.props.clientall,
                                    'value': 'client-id',
                                    'label': 'client-name'
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Client"
                                disabled={this.state.disableHead}
                                hasError={errors.has('client-id')}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Division * </span>
                        <div className="col-sm-4">
                            <ComboboxInput
                                field='division-id'
                                value={form.get('division-id')}
                                options={fromJS({
                                    'source': this.props.divisionall,
                                    'value': 'division-id',
                                    'label': 'division-name'
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Division"
                                disabled={this.state.disableHead}
                                hasError={errors.has('division-id')}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Sender * </span>
                        <div className="col-sm-4">
                            <ComboboxInput
                                field='sender-id'
                                value={form.get('sender-id')}
                                options={fromJS({
                                    'source': this.props.senderall,
                                    'value': 'sender-id',
                                    'label': 'sender-name'
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Sender"
                                disabled={this.state.disableHead}
                                hasError={errors.has('sender-id')}
                            />
                        </div>
                    </div>


                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Start Date *</span>
                        <div className="col-sm-4">
                            <DatePickerInput
                                dateFormat="yyyy-MM-dd"
                                convertvalue
                                field="start-date"
                                value={ form.get('start-date') }
                                onChange={(field, date) => this.handleChange(field, date)}
                                minDate={new Date(moment().subtract(3, "month").format("YYYY-MM-DD "))}
                                maxDate={new Date()}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">End Date *</span>
                        <div className="col-sm-4">
                            <DatePickerInput
                                convertvalue
                                dateFormat="yyyy-MM-dd"
                                field="end-date"
                                value={ form.get('end-date') }
                                onChange={(field, date) => this.handleChange(field, date)}
                                // minDate={new Date(form.get('start-date'))}
                                minDate={new Date(moment().subtract(3, "month").format("YYYY-MM-DD "))}
                                maxDate={new Date()}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">conversationType</span>
                        <div className="col-sm-4">
                            <ComboboxInput
                                field='conversation-type'
                                value={form.get('conversation-type')}
                                options={fromJS({
                                    'source': conversationType,
                                    'value': 'conversation-type-id',
                                    'label': 'conversation-type-name'
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Conversation Type"
                                disabled={ disabled }
                                hasError={errors.has('conversation-type')}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Report Format *</span>
                        <div className="col-sm-4">
                            <ComboboxInput
                                field='report-format'
                                value={form.get('report-format')}
                                options={fromJS({
                                    'source': reportFormat,
                                    'value': 'reportFormat-id',
                                    'label': 'reportFormat-name'
                                }) }
                                onChange={(field, value, label) => this.handleChange(field,value,label)}
                                placeholder="Report Format"
                                disabled={ disabled }
                                hasError={errors.has('report-format')}
                            />
                        </div>
                    </div>

                    {this.renderFormName(form, errors)}

                    <div className="row no-margin-bottom">
                        <span className="col-sm-1"></span>
                        <div className="col-sm-10">
                            <button type="button"
                                    className="btn btn-wide btn-danger"
                                    value="Cancel"
                                    onClick={ this.handleCancel }>
                                Cancel
                            </button>
                            <button type="button"
                                    className="btn btn-wide btn-success"
                                    onClick={ this.handleSubmit }>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderFormName(form, errors){
        if(this.props.actionType === IsEdit){
            return(
                <div className="row no-margin-bottom">
                    <span className="col-sm-1">Name</span>
                    <div className="col-sm-10">
                        <TextInputField className="form-control"
                                        field={'spv-name'}
                                        value={ form.get('spv-name')}
                                        onChange={(field, value) => this.handleChange(field,value)}
                                        placeholder="name"
                                        hasError={errors.has('spv-name')}
                        />
                    </div>
                </div>
            )
        }
    }

}


export default connect(
    (state) => {
        return {
            Users: state.user.users,
            userall: state.user.userall,
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
            accessmoduleaction: state.user.accessmoduleaction,
        }
    },
    dispatch => bindActionCreators({
        actionAdd: ActionAdd,
        actionEdit: ActionEdit,
        actionGetAllClient: ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
        actionGetAccessModuleIdAction:ActionGetAccessModuleIdAction,
    }, dispatch),
)(Form);